module.exports = __webpack_public_path__ + "static/media/Suchfunktion.786d99db.pdf";